module.exports = {
  // General Okay Respponse [HTTP: OK]
  OKAY: 200,

  // User is not allowede to access resource [HTTP: Forbidden]
  ERROR_ACCESS_RESTRICTED: 403,

  // Request resource not found [HTTP: Not Found]
  ERROR_NOT_FOUND: 404,

  // Parameters sent to API is not valid  [HTTP: Precondition Failed]
  ERROR_API_PARAMS: 412,

  // File type is not supported [HTTP: Unsupported Media Type]
  ERROR_UNSUPPORTED_TYPE: 415,

  // DB method encountered an error [HTTP: Unprocessable Entity]
  ERROR_DB_METHOD: 422,

  // DB sub-method encountered an error  [HTTP: Conflict]
  ERROR_DB_SUBMETHOD: 409, 

  // Data was expected but gone missing (corrupted?)  [HTTP: Gone]
  ERROR_DB_MISSING: 410,

  // Unknown error encoutered on VUE code  [HTTP: I'm a teapot]
  ERROR_VUE: 418,

}
